import { Workbook } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationWorkbook = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
): Promise<NonPaginatedResponse<Workbook> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/workbook`, {
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
